import { useTweaks } from '../components/Tweaks.jsx';
import { Header } from '../components/Header.jsx';
import { Footer } from '../components/Blocks.jsx';
import { CCHero, CCFeature, CCGrid, CCOutro } from '../components/CelebrityCoaching.jsx';

const TWEAK_DEFAULTS = {
  navWelshResources: 'Welsh Resources',
  navCommunity: 'Community',
  navAboutUs: 'About us',
  navBlog: 'Blog',
  navContact: 'Contact',
  login: 'Login',
  startLearning: 'Start Learning',

  ccKicker: 'Iaith ar Daith - language on a journey',
  ccTitle: 'How Jeremy Vine inspired a TV series - and 18 celebrities learned Welsh.',
  ccLede: 'In 2019, broadcaster Jeremy Vine learnt Welsh with our methodology author Aran live on Radio 2. He also paid for 10 people to do the full intensive SaySomethinginWelsh course. S4C noticed. They commissioned a series. Four series later, every famous face below has done the same intensive coaching, with Aran, on camera.',
  ccFeatTag: 'The original',
  ccFeatKicker: 'Where it all started',
  ccFeatTitle: 'The session that started everything.',
  ccFeatBody: 'The full Radio 2 session from 2019 – Aran teaching Jeremy his first ten minutes of Welsh, live on air. It was meant to be a one-off feature. S4C saw it, commissioned Iaith ar Daith on the strength of it, and four series later every famous face below has done the same coaching. Available here in full for the first time.',
  ccFeatChip1: 'BBC Radio 2',
  ccFeatChip2: '2019',

  ccGridTitle: 'Every coaching session, in one place.',
  ccGridSub: 'From Ruth Jones to Joe Ledley, four years of Iaith ar Daith.',

  ccOutroTitle: 'The same method these celebrities used.',
  ccOutroBody: "What you saw above isn't a TV trick — it's the SaySomethingin Method, built around forced spoken production from the very first lesson. Anyone can do this.",
  ccOutroCta1: 'Try the method →',
  ccOutroCta2: 'Buy a gift voucher',

  footerCta: 'Start your language learning journey today.',
  footerCta1: 'Start Learning',
  footerCta2: 'Get our newsletter',
  footerCol1: 'What we do',
  footerCol2: 'SaySomethingin Learners',
  footerCol3: 'Download',
  footerLegal: '© 2026 SaySomethingIn Cyf. Glaslyn, Ffordd y Parc, Bangor, Gwynedd LL57 4FE, Wales.',
};

const GROUPS = [
  { name: 'Header', keys: ['navWelshResources','navCommunity','navAboutUs','navBlog','navContact','login','startLearning'] },
  { name: 'Hero', keys: ['ccKicker','ccTitle','ccLede'], long:['ccTitle','ccLede'] },
  { name: 'Featured session', keys: ['ccFeatTag','ccFeatKicker','ccFeatTitle','ccFeatBody','ccFeatChip1','ccFeatChip2'], long:['ccFeatTitle','ccFeatBody'] },
  { name: 'Grid header', keys: ['ccGridTitle','ccGridSub'], long:['ccGridSub'] },
  { name: 'Outro', keys: ['ccOutroTitle','ccOutroBody','ccOutroCta1','ccOutroCta2'], long:['ccOutroBody'] },
  { name: 'Footer', keys: ['footerCta','footerCta1','footerCta2','footerCol1','footerCol2','footerCol3','footerLegal'], long:['footerCta','footerLegal'] },
];

export default function CelebrityCoaching() {
  const { tweaks, panel } = useTweaks({ defaults: TWEAK_DEFAULTS, groups: GROUPS });
  return (
    <div data-screen-label="Celebrity coaching">
      <Header t={tweaks} isHomepage={false}/>
      <main>
        <CCHero t={tweaks}/>
        <CCFeature t={tweaks}/>
        <CCGrid t={tweaks}/>
        <CCOutro t={tweaks}/>
      </main>
      <Footer t={tweaks} hideCta={true}/>
      {panel}
    </div>
  );
}
